module.exports = __webpack_public_path__ + "./images/05ae4a2af5cf858cec2e30876c2b412c.webp";